<section class="customer-love-section">
  <div class="customer-love-container">
    <div class="customer-love-content">
      <span class="section-label">{{ 'users_review.label' | translate }}</span>

      <h2>{{ 'users_review.title' | translate }}</h2>

      <p>
        {{ 'users_review.description' | translate }}
      </p>

      <div class="customer-love-stats">
        <div>
          <strong>4.3 / 5</strong>
          <span>{{ 'users_review.trustpilot_rating' | translate }}</span>
        </div>

        <div>
          <strong>{{ 'users_review.free' | translate }}</strong>
          <span>{{ 'users_review.ats_resume_checker' | translate }}</span>
        </div>

        <div>
          <strong>{{ 'users_review.fast' | translate }}</strong>
          <span>{{ 'users_review.resume_creation' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="customer-love-card">
      <div class="stars">★★★★★</div>

      <p class="review-text">
        Easy to use, various customization options, no need to start from scratch - I uploaded my previous CV and built
        on it. Looks nice and clean and doesn’t cost a fortune as many others.
      </p>

      <div class="review-author">
        <div class="avatar">OS</div>
        <div>
          <strong>Olga S</strong>
          <span>{{ 'users_review.review_author_desc' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</section>
